import React, { useEffect, useState } from "react";
import { login, loginGoogle, loginFacebook, register, loginUnique, loginPrize, } from "../../function/auth";
import { Spin } from "antd";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "@mui/material";

import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
// import { Button } from '@mui/material';

import logo from "./logo/logo.png";
import { BsFacebook } from 'react-icons/bs';
import { FcGoogle } from "react-icons/fc";
import { SiLine } from "react-icons/si";

import axios from 'axios';

import { auth, googleAuthProvider } from "../../firebase";

import { useSelector } from "react-redux";
// import "./Login.css"

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("normal");
  useEffect(() => {
    // window.scrollTo(100, 100);
  })

  useEffect(() => {
    const handleFocusOut = () => {
      window.scrollTo(0, 0);
    };

    window.addEventListener("focusout", handleFocusOut);

    return () => {
      window.removeEventListener("focusout", handleFocusOut);
    };
  }, []);
  const [value, setValue] = useState({
    usernameOrEmail: "",  // เปลี่ยนจาก 'username' เป็น 'usernameOrEmail'
    password: "",
  });
  const [loading, setLoading] = useState(false);


  const roleBaseRedirect = (role) => {
    let intended = location.state;
    if (intended) {
      navigate("../" + intended); // กรณีมีเส้นทางที่ตั้งไว้ล่วงหน้า
    } else {
      if (role === "admin") {
        navigate("/admin/index"); // เส้นทางของ admin
      } else if (role === "employee") {
        navigate("/employ-shop"); // เส้นทางของ employee
      } else if (role === "staff") {
        navigate("/admin/branch")
      }

      else {
        navigate("/"); // เส้นทางของ user
      }
    }
  };

  const handleChange = (e) => {
    setValue({
      ...value,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    setLoading(true);
    e.preventDefault();

    // ส่งค่า usernameOrEmail ไปที่ backend
    const payload = {
      usernameOrEmail: value.usernameOrEmail,
      password: value.password,
    };

    login(payload)
      .then((res) => {
        setLoading(false);
        toast.success(`${res.data.payload.user.username} Login Success`);
        dispatch({
          type: "LOGIN",
          payload: {
            token: res.data.token,
            username: res.data.payload.user.username,
            role: res.data.payload.user.role,
            profileImage: res.data.payload.user.profileImage?.url
          },
        });

        localStorage.setItem("token", res.data.token);
        roleBaseRedirect(res.data.payload.user.role);
        setTimeout(() => {
          window.location.reload();
        }, 500);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err.response.data);
        toast.error("ชื่อผู้ใช้งานหรือรหัสผ่านไม่ถูกต้อง");
      });
  };

  const handleSubmitUnique = (e) => {
    setLoading(true);
    e.preventDefault();
    const payload = {
      username: value.usernameOrEmail, // หรือเปลี่ยนชื่อ field ตามที่ Unique API ต้องการ
      password: value.password,
    };
    loginUnique(payload)
      .then((res) => {
        setLoading(false);
        toast.success(`${res.data.username} Login Success`);
        dispatch({
          type: "LOGIN",
          payload: {
            token: res.data.token,
            username: res.data.username,
            role: res.data.role,
            profileImage: res.data.profileImage?.url
          },
        });
        localStorage.setItem("token", res.data.token);
        roleBaseRedirect(res.data.role);
        setTimeout(() => {
          window.location.reload();
        }, 500);
      })
      .catch((err) => {
        setLoading(false);
        toast.error("Login UniqueCareStation ไม่สำเร็จ");
      });
  };


  const responseFacebook = async (response) => {
    if (response.accessToken) {
      try {
        const { data } = await axios.post(
          `${process.env.REACT_APP_API}/login-facebook`,
          { accessToken: response.accessToken },
          {
            headers: {
              authtoken: response.accessToken, // เพิ่ม authtoken ใน headers
            },
          }
        );

        toast.success(data.user.username + " Login Success");
        dispatch({
          type: "LOGIN",
          payload: {
            token: data.token, // บันทึกโทเค็นที่ได้รับจาก backend
            username: data.user.username,
            role: data.user.role,
          },
        });

        localStorage.setItem("token", data.token); // บันทึกโทเค็นใน localStorage
        localStorage.setItem("user", JSON.stringify(data.user));

        roleBaseRedirect(data.user.role);
      } catch (error) {
        console.error("Facebook login failed:", error);
        toast.error("Facebook login failed");
      }
    }
  };


  const handleLoginByGoogle = async () => {
    try {
      const result = await auth.signInWithPopup(googleAuthProvider);
      const { user } = result;
      const idTokenResult = await user.getIdTokenResult();

      // ส่งข้อมูลไปยัง backend เพื่อบันทึกการล็อกอินของผู้ใช้ Google
      const { data } = await loginGoogle({
        idToken: idTokenResult.token,
        username: user.displayName,
        email: user.email,
        picture: user.photoURL,
      });

      if (data && data.user && data.user.username) {
        dispatch({
          type: "LOGIN",
          payload: {
            token: data.token,
            username: data.user.username,
            email: data.user.email,
            role: data.user.role,
            picture: data.user.picture,
          },
        });

        localStorage.setItem("token", data.token);
        roleBaseRedirect(data.user.role);
      } else {
        console.error("Google login failed: No username returned");
        toast.error("Google login failed: No username returned");
      }

    } catch (err) {
      console.error("Google login failed:", err);
      toast.error("Google login failed");
    }
  };

  const handleLoginByLine = () => {
    const clientId = process.env.REACT_APP_LINE_CLIENT_ID;
    const redirectUri = process.env.REACT_APP_LINE_REDIRECT_URI;
    console.log("LINE CLIENT_ID:", clientId);
    console.log("LINE REDIRECT_URI:", redirectUri);
    console.log("Line Client ID:", clientId);
    const state = "randomState123";
    const scope = "profile openid email";

    const lineLoginUrl = `https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&state=${state}&scope=${scope}`;

    window.location.href = lineLoginUrl;
  };


  const handleSubmitPrize = (e) => {
    setLoading(true);
    e.preventDefault();
    const payload = {
      username: value.usernameOrEmail,
      password: value.password,
    };
    loginPrize(payload)
      .then((res) => {
        setLoading(false);
        toast.success(`${res.data.username} Login Success`);
        dispatch({
          type: "LOGIN",
          payload: {
            token: res.data.token,
            username: res.data.username,
            role: res.data.role,
            profileImage: res.data.profileImage?.url
          },
        });
        localStorage.setItem("token", res.data.token);
        roleBaseRedirect(res.data.role);
        setTimeout(() => {
          window.location.reload();
        }, 500);
      })
      .catch((err) => {
        setLoading(false);
        toast.error("Login PrizeMed ไม่สำเร็จ");
      });
  }


  // const handleLoginByGoogle = async () => {
  //   // code
  //   auth.signInWithPopup(googleAuthProvider)
  //     .then(async (result) => {
  //       //code return data from server
  //      // console.log('result', result)
  //       const { user } = result
  //       const idToken = await user.getIdTokenResult();
  //       //console.log(user.email, idToken.token)

  //       register(idToken.token)
  //       .then((res)=>{
  //         //code
  //         dispatch(login({
  //           email: res.data.email,
  //           name: res.data.name,
  //           token: idToken.token
  //         }))
  //       })
  //       .catch((err)=>console.log(err))

  //     })
  //     .catch((err) => {
  //       // err
  //       console.log(err)
  //     })



  // }

  return (
    <div className="login p-5 ">
      <div className="row justify-content-center mt-2">
        <div
          className="col-md-6"
          style={{
            boxShadow: "0 3px 10px rgba(0, 0, 0, 0.2)",
            padding: "2rem",
            borderRadius: "8px",
            background: "#ffff"
          }}
        >
          {loading ? (
            <h1>
              Loading...
              <Spin />
            </h1>
          ) : (
            <div className="text-center mb-4">
              <img
                src={logo}
                alt="Logo"
                className="img-fluid"
                style={{ maxWidth: "200px" }}
              />
              <h4>เข้าสู่ระบบ</h4>
            </div>
          )}

          <div className="row text-center">
            <div className="col-12 col-md-4 mb-2">
              <button
                className={`btn w-100 fw-bold py-2 ${activeTab === "normal" ? "btn-primary" : "btn-outline-primary"}`}
                onClick={() => setActiveTab("normal")}
              >
                บัญชีทั่วไป
              </button>
            </div>
            <div className="col-12 col-md-4 mb-2">
              <button
                className={`btn w-100 fw-bold py-2 ${activeTab === "unique" ? "btn-success" : "btn-outline-success"}`}
                onClick={() => setActiveTab("unique")}
              >
                UniqueCare
              </button>
            </div>
            <div className="col-12 col-md-4 mb-2">
              <button
                className={`btn w-100 fw-bold py-2 ${activeTab === "prize" ? "btn-warning" : "btn-outline-warning"}`}
                onClick={() => setActiveTab("prize")}
              >
                PrizeMed
              </button>
            </div>
          </div>

          {/* ฟอร์มแต่ละแท็บ */}
          {activeTab === "normal" && (
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Username or Email</label>
                <input
                  className="form-control"
                  type="text"
                  name="usernameOrEmail"
                  value={value.usernameOrEmail}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>Password</label>
                <input
                  className="form-control"
                  type="password"
                  name="password"
                  value={value.password}
                  onChange={handleChange}
                />
              </div>
              <br />
              <div className="d-flex justify-content-center">
                <button className="btn me-3" style={{ backgroundColor: "#FF70A6", color: "#fff" }}>
                  เข้าสู่ระบบ
                </button>
                <button
                  className="btn"
                  style={{ backgroundColor: "#4CB4F6", color: "#fff" }}
                  onClick={() => navigate("/register")}
                  type="button"
                >
                  สมัครสมาชิก
                </button>
              </div>
            </form>
          )}

          {activeTab === "unique" && (
            <form onSubmit={handleSubmitUnique}>
              <div className="form-group">
                <label>Username (UniqueCareStation)</label>
                <input
                  className="form-control"
                  type="text"
                  name="usernameOrEmail"
                  value={value.usernameOrEmail}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>Password</label>
                <input
                  className="form-control"
                  type="password"
                  name="password"
                  value={value.password}
                  onChange={handleChange}
                />
              </div>
              <br />
              <div className="d-flex justify-content-center">
                <button className="btn btn-success">
                  เข้าสู่ระบบ UniqueCareStation
                </button>
              </div>
            </form>
          )}
          {activeTab === "prize" && (
            <form onSubmit={handleSubmitPrize}>
              <div className="form-group">
                <label>Username (PrizeMed)</label>
                <input
                  className="form-control"
                  type="text"
                  name="usernameOrEmail"
                  value={value.usernameOrEmail}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>Password</label>
                <input
                  className="form-control"
                  type="password"
                  name="password"
                  value={value.password}
                  onChange={handleChange}
                />
              </div>
              <br />
              <div className="d-flex justify-content-center">
                <button className="btn btn-warning">
                  เข้าสู่ระบบ PrizeMed
                </button>
              </div>
            </form>
          )}


          {/* <FacebookLogin
            appId="1459334144769319"
            autoLoad={false}
            fields="name,email,picture"
            callback={responseFacebook}
            render={(renderProps) => (
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 2, mb: 2 }}
                onClick={renderProps.onClick}
                startIcon={<BsFacebook />}
            >
              SIGN IN WITH Facebook
              </Button>
            )}
          /> */}
          <Button
            onClick={handleLoginByGoogle}
            variant="contained"
            startIcon={<FcGoogle size={20} />} // ใช้ไอคอน Google
            style={{
              backgroundColor: "#F8F8FF",
              color: "#BEBEBE",
              textTransform: "none",
              fontWeight: "bold",
              padding: "10px 20px",
              borderRadius: "5px",
              marginTop: "20px",
            }}
          >
            Sign in with Google
          </Button>
          <Button
            onClick={handleLoginByLine}
            variant="contained"
            startIcon={<SiLine size={10} />}
            style={{
              backgroundColor: "#06C755",
              color: "#fff",
              textTransform: "none",
              fontWeight: "bold",
              padding: "10px 20px",
              borderRadius: "5px",
              marginLeft: "5px",
              marginTop: "20px",
            }}
          >
            Sign in with LINE
          </Button>

        </div>
      </div>
    </div>
  );
};

export default Login;